module.exports = __webpack_public_path__ + "static/media/S4_01.5d7b5c67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/STAGE4strobe/S4_01.png
// module id = 199
// module chunks = 0